const en = {
	download: 'Download settlement statement',
	filter: {
		webSite: 'Website',
		all: 'All',
		groupName: 'Group',
		transactionId: 'Purchase Transaction ID',
		orderId: 'Merchant Transaction ID',
		date: 'Date',
		selectDate: 'Select the date',
		quicklySelect: {
			lab: 'Quick selection',
			range: {
				today: 'Today',
				lastWeek: 'Last week',
				lastMonth: 'Last month',
				lastYear: 'Last year'
			}
		}
	},
	tableColumns: {
		settlementTime: 'Settlement Time',
		transactionTime: 'Transaction Time',
		transactionComTime: 'Transaction Complete Time',
		transactionID: 'Purchase Transaction ID',
		orderId: 'Merchant Transaction ID',
		gatewayFlowID: 'Gateway Flow ID',
		website: 'Website',
		groupName: 'Group',
		currency: 'Currency',
		amount: 'Amount',
		refundAmount: 'Refund Amount',
		settlementCurrency: 'Settlement Currency',
		settlementExchangeRate: 'Settlement Exchange Rate',
		settlementAmount: 'Settlement Amount',
		deposit: 'Deposit',
		transactionFee: 'Transaction Fee',
		refundFee: 'Refund Fee'
	},
	detail: {
		title: 'Transaction Log',
		refundTitle: 'Refund Log',
		group: 'Group',
		storeName: 'Website',
		omniWebsiteStore: 'Website/Store',
		store: 'Store',
		status: 'Status',
		refundStatus: 'Refund status',
		time: 'Transaction time',
		refundTime: 'Refund time',
		startTime: 'Start time',
		endTime: 'End time',
		orderId: 'Merchant Transaction ID',

		refundOrderId: 'Merchant Refund Transaction ID',
		omniRefundOrderId: 'Merchant Refund Transaction ID',
	    originTransactionId: 'Purchase Transaction ID',
		omniOrderIdTransactionID: 'Merchant Transaction ID/Purchase Transaction ID',
		omniOrderId: 'Merchant Transaction ID',
		omniOrderIdRefundID: 'Merchant Transaction ID/Purchase Transaction ID',
		merchantTransactionId: 'Merchant Transaction ID',
		omniMerchantTransactionId: 'Merchant Transaction ID',

		transactionID: 'Purchase Transaction ID',
		shopifyOrderId: 'Shopify Transaction ID',
		refundTransactionID: 'Refund Transaction ID',
		search: 'Search',
		clear: 'Reset',
		detail: 'details',
		enabled: 'Success',
		disabled: 'Failed',
		export: 'Export current result',
		advancedFilter: 'Advanced Filter',
		orderIdTransactionID: 'Merchant Transaction ID/Purchase Transaction ID',
		orderIdRefundID: 'Merchant Refund Transaction ID/Refund Transaction ID',
		consumer: 'Email/phone number',
		groupStore: 'Website/Group',
		omniGroupStore: 'Store/Website/Group',
		outFlowId: 'Purchase Transaction ID',
		transactionId: 'Transaction ID',
		transactionMode: 'Trading mode',
		cardNo: 'Desensitized card numbers',
		cardTipText: 'Desensitized card numbers can only be searched based on the first six and last four digits of the card number.',
		cardNoError: 'Please enter the first six and last four digits of the card number to search the transaction.'
	},
	invoice: {
		invoice: 'Monthly Invoice',
		desc: 'We will generate the invoice of prior month on the 1st of every month.',
		pickerMonth: 'Select the month',
		fileName: 'File Name',
		month: 'Time period',
		operator: 'Operation',
		download: 'Download',
		create: '文件生成中',
		fail: '文件生成失败'
	},
	statementDownload: {
		statementDownload: 'Settlement Report',
		time: 'Settlement Time：',
		omniTime: 'transaction date：',
		startTime: 'Start time',
		endTime: 'End time',
		fileName: 'File Name',
		type: 'Type',
		tableTime: 'Settlement Time',
		omniTableTime: 'Transaction Date',
		omniSettlementDate: 'Settlement Date',
		action: 'Operation',
		bill: 'BILL',
		date: 'Daily Report',
		week: 'Weekly Report',
		month: 'Monthly Report',
		custom: 'Custom Report',
		confirm: 'Generate the download',
		transactionReport: 'Transaction Statement',
		settlementReport: 'Settlement Statement',
		disputeReport: 'Dispute Statement',
		customReport: 'Customized Statement',
		useTemplate: 'Use Template',
		batchDownload: 'Batch Download',
		tip1: 'A statement for the selected date has already been generated. Please do not regenerate.',
		tip2: 'The %{date} statement is being generated, please wait patiently.'
	},
	statementSetting: {
		title: 'Statement Settings',
		fieldSetting: 'Statement Field Settings',
		getMethod: 'Statement Retrieval Method: ',
		ppCheckout: 'PingPong Checkout',
		sftp: 'PingPong SFTP',
		directory: 'Download Directory',
		tip: 'Must be filled when selecting SFTP. Please contact technical support to add a download directory and configure it here.',
		validTip: 'Please enter the SFTP download directory.',
		format: 'Statement Format:',
		rate: 'Statement Generation Frequency:',
		date: 'Daily',
		week: 'Weekly',
		month: 'Monthly',
		templateName: 'Template Name',
		delTemplate: 'Delete Template',
		fieldName: 'Field Name',
		customTemplate: 'Custom Statement Template',
		delTip: 'Are you sure you want to delete “%{title}?”',
		delTitle: 'Delete Statement Template',
		delConfirm: 'Confirm',
		delCancel: 'Cancel',
		delSuccess: 'Deletion Successful!',
		delCanceled: 'Deletion Cancelled',
		save: 'Save Settings',
		cancel: 'Cancel Settings'
	}
}

export default en
